export default __webpack_public_path__ + "static/media/service-1.7c016a37.jpg";